import * as React from "react";
import Team from "../commons/model/Team";
import Identity from "../commons/model/Identity";
import InvitationDialog from "../commons/components/InvitationDialog";
import EditUserTeamDialog from "./EditUserTeamDialog";
import IdentityText from "../commons/components/IdentityText";
import ImpersonateAction from "../commons/model/ImpersonateAction";
import sfetch from "../commons/utils/super-fetch";
import "./UserSupport.scss";
import { dateWithOptionalTime } from "../commons/utils/date";

interface UserSupportProps {
  teams: Team[];
  selectedTeam?: Team;
  impersonateAction: ImpersonateAction;
  profileUrl: string;
  inviteEndpoint?: string;
}

interface UserSupportState {
  inviteDialogVisible?: boolean;
  userToEdit?: Identity;
}

export default class UserSupport extends React.Component<UserSupportProps, UserSupportState> {
  constructor(props: UserSupportProps) {
    super(props);
    this.state = {};
    this.closeEditUserTeamDialog = this.closeEditUserTeamDialog.bind(this);
    this.editUserTeam = this.editUserTeam.bind(this);
  }

  private showInviteDialog() {
    this.setState({ inviteDialogVisible: true });
  }

  private hideInviteDialog() {
    this.setState({ inviteDialogVisible: false });
  }

  private static reload() {
    document.location.reload();
  }

  render() {
    const { selectedTeam, impersonateAction } = this.props;
    let teams: Team[];
    let tableArea;
    if (selectedTeam) {
      teams = [selectedTeam];
      if (selectedTeam.users.length == 0) {
        tableArea = (
          <div className="table with-shadow empty">
            {" "}
            {i18n["Page.CustomerSupport.NoUserInTeam"]}{" "}
          </div>
        );
      }
    } else {
      teams = this.props.teams;
      const hasUsers = teams.some((team) => team.users.length > 0);
      if (!hasUsers) {
        tableArea = (
          <div className="table with-shadow empty"> {i18n["Page.CustomerSupport.NoUser"]} </div>
        );
      }
    }
    // LongTermFix sjahan 20/06/19: To be migrated to PaginatedList usage.
    if (tableArea == null) {
      tableArea = (
        <table className="table with-shadow" id="users_table">
          <thead>
          <tr>
            <th>{i18n["Page.UserManagement.Column.Name"]}</th>
            <th>{i18n["Page.UserManagement.Column.Email"]}</th>
            <th>{i18n["Page.UserManagement.Column.CreationDate"]}</th>
            <th>{i18n["Page.UserManagement.Column.Team"]}</th>
            <th>{i18n["Page.UserManagement.Column.Action"]}</th>
          </tr>
          </thead>
          <tbody>
          {teams.map((team: Team) =>
            team.users.map((user: Identity) => (
              <tr
                className="clickable"
                onClick={() => (document.location.href = `${this.props.profileUrl}${user.uid}`)}
                key={user.displayName + user.email + team.name}
              >
                <td>
                  <IdentityText identity={user} impersonateAction={impersonateAction} />
                </td>
                <td>{user.email}</td>
                <td>{dateWithOptionalTime(new Date(user.creationDate))}</td>
                <td>{team.name}</td>
                <td>
                    <span
                      className="link"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({ userToEdit: user });
                      }}
                    >
                      <i className="ic_edit" />
                      <span>{i18n["Global.Edit"]}</span>
                    </span>
                </td>
              </tr>
              ))
          )}
          </tbody>
        </table>
      );
    }

    return (
      <>
        <div className="user-management-panel">
          <div className="h-flex align-center space-between">
            <div />
            <h1 className="title">{i18n["Page.CustomerSupport.UsersTitle"]}</h1>
            {this.props.teams.length > 0 && this.props.inviteEndpoint ? (
              <a
                id="invite-button"
                className="button-primary"
                onClick={() => this.showInviteDialog()}
              >
                {i18n["Page.CustomerSupport.Invite"]}
              </a>
            ) : (
              <div />
            )}
          </div>
          {tableArea}
        </div>
        {this.state.inviteDialogVisible ? (
          <InvitationDialog
            title={i18n["Dialog.Invite.CustomerSupport.Title"]}
            submitLabel={i18n["Dialog.Invite.Submit"]}
            inviteEndpoint={this.props.inviteEndpoint}
            onCancel={() => this.hideInviteDialog()}
            onClose={() => UserSupport.reload()}
            teams={this.props.teams}
          />
        ) : null}
        {this.state.userToEdit && (
          <EditUserTeamDialog
            user={this.state.userToEdit}
            teams={this.props.teams}
            close={this.closeEditUserTeamDialog}
            onChange={this.editUserTeam}
          />
        )}
      </>
    );
  }

  editUserTeam(teamUid: string) {
    const team = this.props.teams.find((t) => t.uid === teamUid);
    let result;
    if (!team.users.find((u) => u.uid === this.state.userToEdit.uid)) {
      result = sfetch(team.urlTeamUserEdition, {
        method: "PUT",
        body: JSON.stringify(this.state.userToEdit.uid),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.ok)
        .catch((res) => res.ok);
    } else {
      result = Promise.resolve(false);
    }
    return result.then(this.closeEditUserTeamDialog);
  }

  closeEditUserTeamDialog(reload: boolean) {
    this.setState({ userToEdit: null });
    if (reload) UserSupport.reload();
  }
}
